import styled from 'styled-components';
import { Box } from '../../common/Box';
import BackgroundImage from 'assets/backgrounds/approach.jpg';
import { COLORS } from 'theme/colors';
import MobileBackgroundImage from 'assets/backgrounds/approach-mobile.jpg';
import { SIZES } from 'theme/sizes';
import { Typography } from 'components/common/Typography';

export const StyledContainer = styled(Box)`
  border-top: 1px solid ${COLORS.stroke.primary};

  display: flex;
  flex-direction: column-reverse;

  scroll-margin: 70px;

  ${SIZES.media.desktop} {
    display: grid;
    align-items: center;
    grid-template-columns: minmax(730px, 1fr) minmax(710px, 1fr);
    min-height: calc(100vh - 52px);
    scroll-margin: 0;
  }
`;

export const StyledRightContainer = styled(Box)`
  background-image: url(${MobileBackgroundImage});
  background-size: cover;
  width: 100%;
  height: 363px;

  ${SIZES.media.phone} {
    height: 65vh;
    background-position-y: center;
    background-position-x: center;
  }

  ${SIZES.media.tablet} {
    background-image: url(${BackgroundImage});
  }

  ${SIZES.media.desktop} {
    height: 100%;
  }
`;

export const StyledLeftContainer = styled(Box)`
  padding: ${SIZES.spacing(5)} ${SIZES.spacing(2.5)} ${SIZES.spacing(8)};

  ${SIZES.media.desktop} {
    padding: 0 ${SIZES.spacing(14.5)} 0 ${SIZES.spacing(8)};
  }
`;

export const StyledHeader = styled(Typography)`
  line-height: 38px;
  font-size: 32px;

  ${SIZES.media.desktop} {
    font-size: 48px;
    line-height: 57px;
  }
`;

export const StyledContent = styled(Typography)`
  line-height: 25px;
  font-size: 14px;

  ${SIZES.media.desktop} {
    font-size: 16px;
    line-height: 28px;
  }
`;
